import { useMemo } from 'react';

import {
  getVoucherState,
  isVoucherDownloadable,
  voucherHasResources,
  type Voucher,
  type VoucherState,
} from '@src/domains/vouchers';

export interface VoucherRow {
  voucher: Voucher;
  state: VoucherState;
  isDownloadable: boolean;
}

export function useVoucherRows(vouchers: Voucher[]) {
  const rows = useMemo<VoucherRow[]>(
    () =>
      vouchers.map((voucher) => ({
        voucher,
        state: getVoucherState(voucher),
        isDownloadable: isVoucherDownloadable(voucher),
      })),
    [vouchers],
  );

  const showsResourcesColumn = useMemo(() => voucherHasResources(vouchers), [vouchers]);

  return { rows, showsResourcesColumn };
}
